export default __webpack_public_path__ + "static/media/no_image_card.6ace57aa.png";